import { render, staticRenderFns } from "./ModelHeaderSmall.vue?vue&type=template&id=6501fc51&scoped=true&"
import script from "./ModelHeaderSmall.vue?vue&type=script&lang=js&"
export * from "./ModelHeaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./ModelHeaderSmall.vue?vue&type=style&index=0&id=6501fc51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501fc51",
  null
  
)

export default component.exports